import { render, staticRenderFns } from "./show-big-video.vue?vue&type=template&id=4a94d23a&"
import script from "./show-big-video.vue?vue&type=script&lang=js&"
export * from "./show-big-video.vue?vue&type=script&lang=js&"
import style0 from "./show-big-video.vue?vue&type=style&index=0&id=4a94d23a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports